module.exports = __webpack_public_path__ + "img/MDI-party-popper.e5ecd7fc.svg";